/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
const maxStateCount = 16;
/**
 * A time-range
 */

/**
 * INTERNAL USE ONLY!
 */
export function createDefaultStateSequenceConfiguration(sequenceIndex) {
  return {
    label: `sequence-${sequenceIndex}`,
    stateConfigs: createDefaultStateConfigs()
  };
}
/**
 * Please be aware that at most 16 different states are supported.
 */

/**
 * INTERNAL USE ONLY!
 */
export function sanitizeStateSequenceConfigurations(configs) {
  return configs.map(config => ({
    label: config.label,
    stateConfigs: sanitizeStateConfigs(config.stateConfigs)
  }));
}
/**
 * INTERNAL USE ONLY!
 */

export function sanitizeStateConfigs(stateConfigs) {
  if (stateConfigs === undefined) {
    return stateConfigs;
  }

  if (stateConfigs.length === maxStateCount) {
    return stateConfigs;
  }

  if (stateConfigs.length > maxStateCount) {
    // eslint-disable-next-line
    console.warn(`Up to ${maxStateCount} states per sequence are supported but found ${stateConfigs.length} states. Only the first ${maxStateCount} states will be used.`);
    return stateConfigs.slice(0, maxStateCount);
  }

  const sanitizedStateConfigs = [...stateConfigs];

  while (sanitizedStateConfigs.length < maxStateCount) {
    sanitizedStateConfigs.push(createDefaultState(sanitizedStateConfigs.length));
  }

  return sanitizedStateConfigs;
}
/**
 * INTERNAL USE ONLY!
 */

export function createDefaultStateConfigs() {
  return Array.from({
    length: maxStateCount
  }, (_, valueIndex) => createDefaultState(valueIndex));
}
/**
 * INTERNAL USE ONLY!
 */

export function createDefaultState(configurationIndex) {
  if (configurationIndex < 0 || configurationIndex >= maxStateCount) {
    // eslint-disable-next-line
    console.warn(`configurationIndex must be in [0..${maxStateCount - 1}] but was ${configurationIndex}`);
  }

  return {
    label: `value-${configurationIndex}`,
    stripeStyle: {
      backgroundColor: configurationIndex
    }
  };
}
/**
 * A state of a state-sequence
 */
